import Icon from '@atoms/Icon/Icon';
import { Label, Slider, SliderThumb, SliderTrack } from 'react-aria-components';

export type GridSize = 0 | 50 | 100 | 150;

interface Props {
  readonly defaultSize?: GridSize;
  readonly gridSizeLabel?: string;
  readonly label?: string;
  readonly range?: GridSize[];
  readonly setValue: (size: GridSize) => void;
  readonly value: GridSize;
}

const step = 50;

const GridSlider = ({
  defaultSize = 50,
  gridSizeLabel,
  label = 'Grid Slider',
  range = [0, 50, 100],
  setValue,
  value,
}: Props) => {
  const max = range[range.length - 1] ?? 100;
  const min = range[0] ?? 0;

  return (
    <Slider
      minValue={min}
      maxValue={max}
      step={step}
      defaultValue={defaultSize}
      value={value}
      onChange={setValue}
    >
      <Label className="tw-sr-only">{label}</Label>
      <div className="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-1 rtl:tw-flex-row-reverse">
        {gridSizeLabel && (
          <span className="tw-my-auto tw-mr-4 tw-text-sm tw-uppercase tw-text-grey-70">
            {gridSizeLabel}
          </span>
        )}

        <button
          // TODO: localise labels
          aria-label="reduce grid size"
          onClick={(e) => {
            e.preventDefault();
            setValue(value === min ? min : ((value - step) as GridSize));
          }}
        >
          <Icon
            name="large-grid"
            size="1.5rem"
            className={value < max ? 'tw-fill-grey-100' : 'tw-fill-grey-40'}
          />
        </button>
        {range.length > 2 && (
          <div className="tw-w-full tw-px-xxs md:tw-w-[264px] lg:tw-w-[240px]">
            <SliderTrack className="tw-h-[2px] tw-w-full tw-bg-grey-40">
              <span
                className="tw-absolute tw-left-0 tw-h-[2px] tw-bg-grey-100"
                style={{ width: `${value}%` }}
              />
              <SliderThumb className="tw-h-xs tw-w-xs tw-cursor-grab tw-rounded-full tw-bg-grey-100 tw-transition-all" />
            </SliderTrack>
          </div>
        )}
        <button
          // TODO: localise labels
          aria-label="increase grid size"
          onClick={(e) => {
            e.preventDefault();
            setValue(value === max ? max : ((value + 50) as GridSize));
          }}
        >
          <Icon
            name="small-grid"
            size="1.5rem"
            className={value === max ? 'tw-fill-grey-100' : 'tw-fill-grey-40'}
          />
        </button>
      </div>
    </Slider>
  );
};

export default GridSlider;
